<template>
  <el-config-provider :locale="currentLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '@/composables/useEnhancedI18n.ts'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'

const { locale } = useI18n()

const currentLocale = computed(() => {
  if (locale.value === 'zh-CN') {
    return zhCn
  } else if (locale.value === 'en-US') {
    return en
  }
  return en
})
</script>
<style lang="scss">
@use '@sgs/smart-components-v3/dist/assets/style_components/color.scss' as smart;

@font-face {
  font-family: 'Regular';
  src: url('/fonts/SuisseIntl-Regular-WebS.woff') format('woff');
}
@font-face {
  font-family: 'Roboto-Regular';
  src: url('/fonts/Roboto-Regular.ttf') format('truetype');
}
@font-face {
  font-family: 'UniversLT';
  src: url('/fonts/Univers-LT-55-Roman.ttf') format('truetype');
}
@font-face {
  font-family: 'localArial';
  src: url('/fonts/Arial.ttf') format('truetype');
}
@font-face {
  font-family: '思源黑体';
  font-weight: 350;
  src:
    url('//at.alicdn.com/wf/webfont/280FyQakdv9L/2PrR3QzsBPm5DH8ZtGVEc.woff2')
      format('woff2'),
    url('//at.alicdn.com/wf/webfont/280FyQakdv9L/zwqP3zyrOYxnoT6LnbgXb.woff')
      format('woff');
  font-display: swap;
}

/* 详情通用样式 */
.smart-detail-cotainner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 16px 32px 50px 32px;

  // .top-box {
  //   padding: 64px 32px;
  //   margin-bottom: 32px;
  //   background: #fff;

  //   .title-and-buttons {
  //     display: flex;
  //     justify-content: space-between;
  //   }
  //   .detail-info-box {
  //     margin-top: 64px;
  //   }
  //   .left-box {
  //     display: flex;
  //     flex-direction: column;
  //     gap: 8px;
  //   }
  // }

  .topbar {
    padding: 30px 0 20px 30px;
  }

  .main {
    flex: 1;
    margin-right: 32px;
    overflow: auto;
    // background: smart.$module-background-color;
  }

  .new-main{
    flex: 1;
    overflow: auto;
  }

  .side {
    width: 400px;
    transition: width 0.3s ease;

    &.collapsed {
      width: 90px;
    }
  }
}
.main-left {
  .filter-tags-section {
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 10px;
    padding: 13px 32px 13px 18px;

    .filter-tags {
      display: flex;
      align-items: center;
      flex: 1;
      width: fit-content;

      .filter-tag {
        background: transparent;
        border: none;
        border-bottom: 2px solid transparent;
        border-radius: 0;
        margin: 2px 15px;
        font-size: 16px;
        color: smart.$title-color-sub;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        font-weight: 500;

        &::before {
          position: absolute;
          left: -15px;
          top: 50%;
          transform: translateY(-50%);
          content: '';
          display: block;
          width: 2px;
          height: 15px;
          background-color: #999;
          border-radius: 1px;
        }

        &:first-child {
          &::before {
            display: none;
          }
        }

        &:hover {
          color: smart.$primary-color;
        }

        &--active {
          background: transparent;
          color: smart.$primary-color;
          border-bottom-color: smart.$primary-color;
        }
      }

      .filter-tag--active {
        font-weight: bold;
      }
    }
  }
}
.right-main-content {
  background-color: smart.$module-background-color;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 16px;
}
</style>
